import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import {
  verification,
  fetchUsers,
  userChangeEtat, sendAccesUser
} from "../../../Redux/usersReduce";

import SweetAlert from "react-bootstrap-sweetalert";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from 'react-multi-lang'
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";

// core components
function ListUser({ obj,client }) {
  let lang = window.localStorage.getItem("lang");
  const [loader, setLoader] = useState(true);
  const annee = localStorage.getItem("annee");
  const [alert, setAlert] = useState(null);
  const t = useTranslation();
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>
          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>
          <i className="fas fa-exclamation-circle"></i>
          {msg}
        </strong>
      );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  const confirmMessage = (id) => {

    setAlert(
      <SweetAlert
        title="Êtes-vous sûr d'envoyé les accès ?"
        style={{ display: "block", marginTop: "-100px" }}
        success
        onConfirm={() => sendAcces(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
      </SweetAlert>
    );

  };

  const navigate = useHistory();
  var idRole = obj.user.id_role;
  const dispatch = useDispatch();
  const [entities, setEntities] = React.useState([]);
  const [columns] = React.useState([
    //column definitions...
    {
      header: t("User.name"),
      accessorKey: "nom_prenom",
    },
    {
      header: t("User.login"),
      accessorKey: "login",
    },
    {
      header: t("User.role"),
      accessorKey: "roles.nom",
      Cell: ({ cell }) => cell.row.original.roles.nom,
    },
    {
      header: t("User.email"),
      accessorKey: "email",
    },
    {
      header: t("etat"),
      accessorKey: "etat",
      Cell: ({ cell }) =>
        cell.row.original.etat === 1 ? t("enabled") : t("disabled"),
    },
    {
      accessorKey: "id",
      header: "actions",
      Cell: ({ cell, row }) => (
        idRole == 1 && (
          <div className="actions-right block_action">
            <Button
              onClick={() => {
                navigate.push(client+"/utilisateur/update/" + cell.row.original.id);
              }}
              variant="warning"
              size="sm"
              className="text-warning btn-link edit"
            >
              <i className="fa fa-edit" />
            </Button>
            <Button
              onClick={(event) => {
                changeEtat(cell.row.original.id, cell.row.original.etat);
              }}
              variant="danger"
              size="sm"
              className={
                cell.row.original.etat === 1
                  ? "text-success btn-link delete"
                  : "text-danger btn-link delete"
              }
            >
              <i
                className={
                  cell.row.original.etat === 1 ? "fa fa-check" : "fa fa-times"
                }
              />
            </Button>
          </div>
        )
      ),
    }, {
      accessorKey: "Envoyer",
      header: "Envoyer",
      Cell: ({ cell, row }) => (
        idRole == 1 && (
          <div className="actions-right block_action">
            <Button
              onClick={(event) => {
                confirmMessage(cell.row.original.id);
              }}
              variant="danger"
              size="sm"
              className="btn-success"
            >
              Envoyer les accès
            </Button>
          </div>
        )
      ),
    },
    //end
  ]);
  function ajouter() {
    navigate.push(client+"/ajouterUtilisateur");
  }

  const getUser = useCallback(async () => {
    var response = await dispatch(fetchUsers());
    setEntities(response.payload);
    setLoader(false)
  }, [dispatch]);


  function changeEtat(id, e) {
    dispatch(userChangeEtat(id)).then((e1) => {
      getUser();
      switch (e) {
        case 0:
          notify(1, t("enable"));
          break;
        case 1:
          notify(1, t("disable"));
          break;
        default:
          break;
      }
    });
  }

  function sendAcces(id) {
    hideAlert()
    dispatch(sendAccesUser(id)).then((e) => {
      if (e.payload === true) {
        notify(1, "Envoyé avec succès");
        setTimeout(() => {
          getUser();
        }, 200);
      } else {
        notify(2, t("erreur"));
      }
    });
  }
  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getUser();
  }, [getUser]);

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        positionGlobalFilter="right"
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}
        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }

  return (
    <>
      <Container fluid>
        {alert}
        <ToastContainer />
        <Row>
          {idRole == 1 && (
            <Col md="8">
              <Button
                className="btn-wd  mr-1 float-left btn-info "
                type="button"
                onClick={ajouter}
              >
                <span className="btn-label">
                  <i className="fas fa-plus"></i>
                </span>
                {t("User.add")}
              </Button>
            </Col>)}

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("User.listU")}
                  <Button
                    onClick={(event) => {
                      confirmMessage(0);
                    }}
                    variant="danger"
                    size="sm"
                    className="btn-success mx-1"
                  >
                    Envoyer les accès
                  </Button>

                </Card.Title>
              </Card.Header>
              <Card.Body className="padding-0">
                <ListTable list={entities} loader={loader}></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListUser;
